import styled, { css } from 'styled-components';

import { media } from '../../../theme/media';
import { H2, spacedHeading, smallParagraph } from '../../../theme/typography';
import { themeColor, themeSize, themeColorWithOpacity } from '../../../theme/getters';
import { Input as InputBase } from '../input';

export const Form = styled.form``;

export const Title = styled(H2)`
  ${spacedHeading};
  margin-top: 54px;
`;

export const JudoForm = styled.div`
  margin-top: 56px;
  width: 100%;
  height: 200px;
`;

export const Errors = styled.div`
  width: 100%;
  color: ${themeColor('error')};
  margin-bottom: 16px;

  br {
    display: none;
  }
`;

export const NameFields = styled.div`
  margin-top: 56px;

  ${media.tablet`
    display: flex;

    > div {
      margin-right: 16px;

      &:last-child {
        margin-right: 0;
      }
    };
  `}
`;

export const Input = styled(InputBase).attrs(() => ({
  containerStyles: css`
    padding-bottom: 16px;
  `,
}))`
  border-radius: 0;
`;

export const ButtonWrapper = styled.div`
  padding: 0 ${themeSize('contentPadding')}px;

  ${media.tablet`
    padding: 0;
  `}
`;

const infoTextStyles = css`
  ${smallParagraph};
  font-size: 14px;

  ${media.tablet`
    font-size: 16px;
  `};
`;

export const Info = styled.div`
  padding-top: 24px;
  ${infoTextStyles};
`;

export const LogOut = styled.span`
  position: relative;
  cursor: pointer;
  ${infoTextStyles};

  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -3px;
    background-color: ${themeColorWithOpacity('primary', 0.2)};
    width: 100%;
    height: 1px;
  }
`;
